import { render, staticRenderFns } from "./BecomePanelist.vue?vue&type=template&id=ab66b632"
import script from "./BecomePanelist.vue?vue&type=script&lang=js"
export * from "./BecomePanelist.vue?vue&type=script&lang=js"
import style0 from "./BecomePanelist.vue?vue&type=style&index=0&id=ab66b632&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports